import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class RowUiService {
    private renderer2: Renderer2;

    constructor(@Inject(DOCUMENT) private document: any, private renderFactory: RendererFactory2) {
        this.renderer2 = this.renderFactory.createRenderer(null, null);
    }

    removeRowClass() {
        const outlet = this.document.body.querySelector('#main-router-outlet');
        if (outlet) {
            this.renderer2.removeClass(outlet, 'row');
        }
    }

    addRowClass() {
        const outlet = this.document.body.querySelector('#main-router-outlet');
        if (outlet) {
            this.renderer2.addClass(outlet, 'row');
        }
    }
}
